import { Component, OnInit } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { OkAloneService } from 'src/app/ok-alone.service';

import * as _ from 'lodash-es';
declare var require: any;

@Component({
  selector: 'app-alertloops-upload',
  templateUrl: './alertloops-upload.component.html',
  styleUrls: ['./alertloops-upload.component.scss']
})
export class AlertloopsUploadComponent implements OnInit {

  falseVal = false;

  uploader: FileUploader;
  hasBaseDropZoneOver: boolean;
  hasAnotherDropZoneOver: boolean;
  response: string;

  alertloops: any = null;
  alertloops2: any = null;

  step = 1;

  upload_errors = false;

  file_error = "";

  constructor(public okService: OkAloneService) {

    this.hasBaseDropZoneOver = false;
    this.hasAnotherDropZoneOver = false;

    let url = this.okService.getUrl('alertloops/upload');
    this.uploader = new FileUploader({ url: url });

    this.response = '';

    this.setupLoader();
  }

  setupLoader() {

    let url: any = this.okService.getUrl('alertloops/upload');

    let token = "Bearer " + this.okService.session.token;

    let headers: { name: string; value: string }[] = [];
    if (this.okService.session.cid) {
      headers.push({ name: 'cid', value: this.okService.session.cid });
    }

    this.uploader = new FileUploader({
      url: url,
      authToken: token,
      headers: headers,
      itemAlias: "upload",
      disableMultipart: false,
    });

    this.uploader.onAfterAddingFile = (item => {
      item.withCredentials = false;
    });

    this.uploader.response.subscribe(res => {

      this.file_error = "";

      let data = JSON.parse(res);

      if (data['error']) {
        this.file_error = data['error'];
      } else {

        this.upload_errors = false;
        this.alertloops = data;

        let self = this;
        _.forEach(this.alertloops, function (alertloop: any) {
          if (alertloop.errors && alertloop.errors.length > 0) {
            self.upload_errors = true;
          }
        });

        this.step = 2;
      }

    });

  }

  uploadAlertLoops() {

    this.okService.post("alertloops/upload", { "alertloops": this.alertloops })
      .subscribe((data) => {

        this.alertloops2 = data.body;
        this.step = 3;

      });
  }

  ngOnInit(): void {
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  reset() {
    this.upload_errors = false;
    this.alertloops = null;
    this.setupLoader();
    this.step = 1;
  }

  getMonitorNames(alertloop: any): string {
    let names: string[] = [];
    for (let i = 1; i <= 6; i++) {
      if (alertloop['monitor' + i]) {
        names.push(alertloop['monitor' + i]);
      }
    }
    return names.join(', ');
  }

}
